import { React, models, kea, history, resources, selectores } from "app/main/std";
import { componentToRx } from "app/logic/rx";
import { fa } from "typed-font-awesome";
import { PaginaInicio } from "app/features/general/diseño";

export class PaginaUruz extends React.PureComponent {

    render() {
        return (
            <div>
                <PaginaInicio />
            </div>
        )
    }
}


class WelcomeNoRx extends React.PureComponent<{ permisos: models.Rol }> {
    onDescargarAPK = async () => {
        if (await kea.yesno("¿Descargar App?", )) {
            const apk = await resources.ConfigSistema.GetApk();
            kea.download(kea.base64ToBlob(apk, 'application/vnd.android.package-archive'), "Uruz App.apk");
        }
    }

    render() {
        const permisos = this.props.permisos;

        return (
            <div>
                <kea.Title titulo="Bienvenido al portal Uruz" />
                {
                    permisos.VerBotonDescargarApp &&
                    <kea.Button onClick={this.onDescargarAPK} style="success" iconClass={fa("android")} >
                        Descargar app
                    </kea.Button>
                }
            </div>
        )
    }
}

export const Welcome = kea.defaultProps(componentToRx(WelcomeNoRx), { permisos: resources.User.PermisoRx });


// WEBPACK FOOTER //
// ./app/features/inicio/welcome.tsx